// extracted by mini-css-extract-plugin
export default {"dropdownBox":"Dropdown_dropdownBox__x7Fn+","dropdownContainer":"Dropdown_dropdownContainer__XN-cl","navLinks":"Dropdown_navLinks__et0wK"};